/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Quicktools_InfoInputs */



/**
* | output |
* | --- |
* | "Info" |
*
* @param {Options_Quicktools_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_quicktools_info = /** @type {((inputs?: Options_Quicktools_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Quicktools_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Infos")
	if (locale === "de") return /** @type {LocalizedString} */ ("Info")
	if (locale === "it") return /** @type {LocalizedString} */ ("Informazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Информация")
	if (locale === "es") return /** @type {LocalizedString} */ ("Información")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("信息")
	if (locale === "ja") return /** @type {LocalizedString} */ ("情報")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जानकारी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Informações")
	return /** @type {LocalizedString} */ ("Info")
});